<div class="grid field col-12">
  @if (messages.length > 0) {
    <div class="grid field col-12">
      @for (m of messages; track m; let i = $index) {
        <p-message
          [severity]="asMessageSeverity(m.severity)"
          >{{ m.summary ? (m.detail ? m.summary + ': ' + m.detail : m.summary) : m.detail }}
        </p-message>
      }
    </div>
  }
  @if (!everythingReady) {
    <p-progressSpinner></p-progressSpinner>
  }
  @if (everythingReady) {
    <div class="grid field col-12">
      <div class="col-12 md:col-6"><h2 class="page-title">Devices</h2></div>
      <div class="col-12 md:col-4 button-bar mb-2">
        <button pButton type="button" (click)="navigateToAddDevice()" class="add-button">
          <i pButtonIcon class="fa fa-plus"></i>
          <span pButtonLabel>Add</span>
        </button>
        @if (user?.isGlobalAdmin) {
          <button pButton type="button" (click)="navigateToDiagnostics()" class="diagnostics-button">
            <i pButtonIcon class="fa fa-heartbeat"></i>
            <span pButtonLabel>Diagnostics</span>
          </button>
        }
      </div>
      <div class="col-12 md:col-2 show-deleted-toggle mb-2">
        <p-checkbox inputId="showDeletedToggle" [(ngModel)]="showDeleted" binary="true" (onChange)="onShowDeletedChange()"></p-checkbox>
        <label for="showDeletedToggle">Show deleted</label>
      </div>
      <div class="col-12">
        <p-table #dt [columns]="cols" [value]="devices" [scrollable]="true" [paginator]="true" [rows]="25" [resizableColumns]="true" [loading]="!devicesReady">
          <!-- <ng-template #colgroup let-columns>
          <colgroup>
          <col *ngFor="let col of columns" [style.width]="col.width" />
        </colgroup>
      </ng-template> -->
      <ng-template #header let-columns>
        <tr>
          @for (col of columns; track col) {
            <th [pSortableColumn]="col.field">
              {{col.header}}
              @if (col.field != '') {
                <p-sortIcon [field]="col.field"></p-sortIcon>
              }
            </th>
          }
        </tr>
        <tr>
          @for (col of columns; track col) {
            <th pResizableColumn>
              @switch (col.field) {
                @case ('id') {
                  <div>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" class="filter-input"
                      />
                    </div>
                  }
                  @case ('name') {
                    <div>
                      <input pInputText type="text" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" class="filter-input"
                        />
                      </div>
                    }
                    @case ('category') {
                      <p-multiSelect [options]="deviceCategories" placeholder="Categories" (onChange)="dt.filter($event.value, col.field, col.filterMatchMode)"
                      appendTo="body"></p-multiSelect>
                    }
                    @case ('deletedStatus') {
                      <p-select [options]="deletedFilterOptions" placeholder="Deleted" [showClear]="true"
                      (onChange)="dt.filter($event.value, col.field, 'equals')" appendTo="body"></p-select>
                    }
                  }
                </th>
              }
            </tr>
          </ng-template>
          <ng-template #body let-device>
            <tr [ngClass]="{'deleted-device': device.isDeleted}">
              <td class="ui-resizable-column">{{device.id}}</td>
              <td class="ui-resizable-column">{{device.name}}</td>
              <td class="ui-resizable-column">{{device.category}}</td>
              <td class="ui-resizable-column">{{device.companyName}}</td>
              <td class="ui-resizable-column">{{device.deletedStatus}}</td>
              <td class="ui-resizable-column">{{device.activeStatus}}</td>
              <td class="ui-resizable-column">
                <i class="far fa-edit fa-xl edit-icon" (click)="navigateToDetail(device.id)"></i>
                @if (isAdmin(device) && !device.isDeleted) {
                  <i class="far fa-trash-alt fa-xl" (click)="confirmDelete(device)"></i>
                }
                @if (isAdmin(device) && device.isDeleted) {
                  <i class="fa fa-undo fa-xl restore-icon" (click)="confirmUndelete(device)"></i>
                }
              </td>
            </tr>
          </ng-template>
          <ng-template #paginatorleft>
            Showing {{(dt.totalRecords) < 1 ? 0 : ((dt.first ?? 0) + 1)}} to
            {{(dt.totalRecords) > 0 ? (((dt.rows ?? 0) + (dt.first ?? 0)) <= (dt.totalRecords) ? ((dt.rows ?? 0) + (dt.first ?? 0)) :
            (dt.totalRecords)) : 0}} of {{dt.totalRecords}} entries
          </ng-template>
        </p-table>
      </div>
    </div>
  }
</div>

